import { render, staticRenderFns } from "./TasinirEkleForm.vue?vue&type=template&id=64fe98cb"
import script from "./TasinirEkleForm.vue?vue&type=script&lang=ts"
export * from "./TasinirEkleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports